/**
 * map iterates through the provided object, and returns an object whose values have been run
 * through the iteratee parameter function.
 *
 * @param object the object to iterate over
 * @param iteratee Function used to transform the object values per iteration
 */
export const map = <OutputType>(
  object?: Record<string, unknown>,
  iteratee?: (value: unknown) => OutputType
): Record<string, OutputType> =>
  Object.entries(object ?? {}).reduce(
    (accumulatedObject, [key, value]) => ({
      ...accumulatedObject,
      [key]: typeof iteratee === "function" ? iteratee(value) : (value as OutputType),
    }),
    {} as Record<string, OutputType>
  );
